"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORDER_ON_BEHALF = void 0;
const ORDER_ON_BEHALF = exports.ORDER_ON_BEHALF = 'order-on-behalf-banner';
